/**
 * LandingFeatures - Features grid section
 */
import { 
  Shield, 
  Zap, 
  Globe, 
  CreditCard,
  Wallet,
  RefreshCw,
  Users,
  Bell
} from 'lucide-react';
import { useTranslation } from '../../i18n';

const LandingFeatures = () => {
  const { t } = useTranslation();
  
  const FEATURES = [
    {
      icon: Wallet,
      titleKey: 'landing.multiCurrencyWallets',
      descKey: 'landing.multiCurrencyDesc'
    },
    {
      icon: Shield,
      titleKey: 'landing.twoFASecurity',
      descKey: 'landing.twoFADesc'
    },
    {
      icon: Zap,
      titleKey: 'notices.sendReceiveTitle',
      descKey: 'notices.sendReceiveDesc'
    },
    {
      icon: Globe,
      titleKey: 'landing.currencies64Feature',
      descKey: 'landing.currencies64Desc'
    },
    {
      icon: CreditCard,
      titleKey: 'landing.virtualCards',
      descKey: 'landing.virtualCardsDesc'
    },
    {
      icon: RefreshCw,
      titleKey: 'landing.currencyExchange',
      descKey: 'notices.exchangeDesc'
    },
    {
      icon: Users,
      titleKey: 'landing.teamAccounts',
      descKey: 'landing.teamAccountsDesc'
    },
    {
      icon: Bell,
      titleKey: 'landing.smartAlerts',
      descKey: 'landing.smartAlertsDesc'
    }
  ];

  return (
    <section className="py-24 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold mb-4">
            {t('landing.everythingYouNeed')}
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            {t('landing.powerfulFeatures')}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {FEATURES.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={`feature-${index}`}
                className="group p-6 rounded-2xl bg-card border border-border hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-12 h-12 rounded-xl bg-emerald-500/10 flex items-center justify-center mb-4 group-hover:bg-emerald-500 transition-colors">
                  <Icon className="w-6 h-6 text-emerald-600 group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-heading font-semibold text-lg mb-2">{t(feature.titleKey)}</h3>
                <p className="text-muted-foreground text-sm">{t(feature.descKey)}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LandingFeatures;
